export { default as Customer } from './page'


// WEBPACK FOOTER //
// ./src/pages/Customer/index.js